// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useState} from 'react';
import {Agree_dialog} from '../shared/agree_dialog/agree_dialog';

interface i_use_agree_dialog_props {
    on_agree: ()=>void;
    agree_dialog?: (props:object_of<any>)=>JSX.Element;
}
export const use_agree_dialog = (props: i_use_agree_dialog_props)=>{
    const {on_agree, agree_dialog} = props;
    const [show_agree, toggle_agree] = useState(false);
    const on_close = ()=>{ toggle_agree(false); };
    const on_agree_hdl = ()=>{
        on_close();
        on_agree();
    };
    const Dialog = agree_dialog || Agree_dialog;
    const Comp = show_agree && <Dialog on_close={on_close}
      on_agree={on_agree_hdl}/>;
    return [toggle_agree, Comp] as const;
};
